module.exports = __webpack_public_path__ + "static/img/co.3b252a1a.svg";